import { Button, Drawer } from 'core-ui';
import { LogoutIcon, MenuUnfoldIcon } from 'src/assets/icons';
import { RoutePath } from 'src/enums/routePath';
import { unSlash } from 'src/utils/route';
import { Menu, MenuProps, styled } from 'core-ui-2';
import { useNavigate } from 'react-router-dom';
import { handleCustomerLogout } from 'src/services/auth';
import { useSelectedKey } from 'src/hooks/useSelectedKey';
import { truncateText } from 'src/utils/text';

const StyledDrawer = styled(Drawer)`
  .ant-drawer-header {
    background-color: #5272bd;
    height: 64px;
    padding-left: 15px;
    padding-right: 15px;
    .ant-drawer-header-title {
      justify-content: space-between;
      .ant-drawer-title {
        flex: none;
      }
    }
  }
  .ant-drawer-body {
    padding: 10px 20px;
  }
  .ant-drawer-footer {
    padding-bottom: 28px;
    border-top: none;
  }
`;

const StyledMenu = styled(Menu)`
  border-inline-end: none !important;

  .ant-menu-item {
    margin-inline: 0px;
    margin-block: 0px;
    width: 100%;
    border-radius: 0px;
    color: #8c8c8c;
    font-weight: 600;
    padding-left: 8px !important;

    &.ant-menu-item-selected {
      position: relative;
      background-color: #e6f7ff;
      color: #5272bd;
    }
  }
`;

interface IProps {
  open: boolean;
  onClose: () => void;
  userName: string;
  userAvatar: string;
}

const MobileDrawer: React.FC<IProps> = (props) => {
  const { onClose, open, userName, userAvatar } = props;
  const navigate = useNavigate();

  const menuItems: MenuProps['items'] = [
    {
      key: unSlash(RoutePath.CUSTOMER) + RoutePath.INSURANCE_APPLICATION,
      label: '修理同意送信'
    },
    {
      key: unSlash(RoutePath.CUSTOMER) + RoutePath.IMEI,
      label: 'IMEI情報取得'
    },
    {
      key: unSlash(RoutePath.CUSTOMER_HISTORY),
      label: '修理履歴'
    },
    {
      key: unSlash(RoutePath.CUSTOMER) + RoutePath.SUBSCRIPTIONS,
      label: '加入プラン管理'
    },
    {
      key: unSlash(RoutePath.CUSTOMER) + RoutePath.PERSONAL_INFO,
      label: '個人情報管理'
    }
  ];

  const key = useSelectedKey(menuItems);

  const handleMenuClick: MenuProps['onClick'] = (info) => {
    navigate(info.key);
    onClose();
  };

  return (
    <StyledDrawer
      open={open}
      onClose={onClose}
      rootClassName="z-[2001]"
      placement="left"
      closeIcon={<img src={MenuUnfoldIcon} alt="menu unfold icon" />}
      width="300px"
      title={
        <div className="flex cursor-pointer items-center">
          <div className="w-10 h-10 rounded-full overflow-hidden">
            <img
              src={userAvatar}
              alt="avatar"
              className="w-full h-full object-cover"
              crossOrigin="anonymous"
            />
          </div>

          <div className="ml-3">
            <p className="leading-5 font-medium text-white text-sm">
              {truncateText(userName, 11)}
            </p>
          </div>
        </div>
      }
      footer={
        <Button
          className="text-custom-error8 border border-custom-error8 w-full py-5 text-xs"
          icon={<img src={LogoutIcon} alt="log out icon" />}
          onClick={handleCustomerLogout}
        >
          <span>ログアウト</span>
        </Button>
      }
    >
      <StyledMenu
        mode="inline"
        items={menuItems}
        onClick={handleMenuClick}
        selectedKeys={[key]}
      />
    </StyledDrawer>
  );
};

export default MobileDrawer;
